import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Reveal from "../Reveal";
import { whatsappLink } from "../../data/services";

export default function StrongCTA() {
  return (
    <section
      data-testid="home-strong-cta"
      className="relative section-pad overflow-hidden"
      style={{ background: "#0A192F" }}
    >
      <div className="absolute inset-0 navy-texture opacity-50" />
      <div
        className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-[0.07]"
        style={{ background: "#C5A059", filter: "blur(80px)" }}
      />
      <div className="container-x relative z-10">
        <Reveal className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5">
            <span
              className="inline-block h-px w-14"
              style={{ background: "#C5A059" }}
            />
            <span
              className="text-xs font-bold uppercase tracking-[0.22em]"
              style={{ color: "#C5A059" }}
            >
              Trabajemos juntos
            </span>
          </div>
          <h2 className="font-serif text-white text-3xl md:text-4xl lg:text-5xl leading-tight">
            ¿Necesitas respaldo jurídico <em className="italic" style={{ color: "#C5A059" }}>confiable</em> para tu empresa?
          </h2>
          <p className="mt-6 text-slate-300 text-base md:text-lg max-w-2xl leading-relaxed">
            Conversemos sobre tu situación. Recibirás una primera lectura técnica del caso y la ruta de acompañamiento más adecuada.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="strong-cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm font-medium text-navy-900 transition-all hover:opacity-90"
              style={{ background: "#C5A059" }}
            >
              <MessageCircle size={17} />
              Agenda una asesoría
            </a>
            <Link
              to="/contacto"
              data-testid="strong-cta-contacto"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm font-medium text-white border border-white/40 hover:bg-white hover:text-navy-900 transition-all"
            >
              Escríbenos
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}